var _rect, _path, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 14,
    fill: "url(#paint0_linear_3995_102199)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 29.75C7.875 27.222 8.37292 24.7189 9.34032 22.3833C10.3077 20.0478 11.7257 17.9257 13.5132 16.1382C15.3007 14.3507 17.4228 12.9327 19.7583 11.9653C22.0939 10.9979 24.5971 10.5 27.125 10.5C29.653 10.5 32.1561 10.9979 34.4917 11.9653C36.8272 12.9327 38.9493 14.3507 40.7368 16.1382C42.5243 17.9257 43.9423 20.0478 44.9097 22.3833C45.344 23.4318 45.6836 24.514 45.9261 25.6171C46.2194 26.8006 46.375 28.0384 46.375 29.3125C46.375 29.3817 46.3745 29.4507 46.3736 29.5197C46.3745 29.5964 46.375 29.6732 46.375 29.75H46.3689C46.1373 38.0045 39.373 44.625 31.0625 44.625C22.752 44.625 15.9877 38.0045 15.7561 29.75H7.875ZM31.0625 36.75C35.1701 36.75 38.5 33.4201 38.5 29.3125C38.5 25.2049 35.1701 21.875 31.0625 21.875C26.9549 21.875 23.625 25.2049 23.625 29.3125C23.625 33.4201 26.9549 36.75 31.0625 36.75Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 13.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3995_102199",
    x1: -5.22785,
    y1: 28,
    x2: 51.0768,
    y2: 53.3258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF597C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp1);
export default __webpack_public_path__ + "static/media/app-1.9bd6b5fc5e9cb6f18f2566473bd31f9b.svg";
export { ForwardRef as ReactComponent };